<template>
  <div
    id="demo-list-container"
    class="demo-list-container"
  >
    <div class="demo-list-content">
      <h1 class="content-title">
        示例中心
      </h1>
      <div class="categoty-list">
        <div
          v-for="category in demoList"
          :id="category.name"
          :key="category.category_id"
          class="categoty-item"
        >
          <div class="categoty-title">
            {{ category.name }}
          </div>
          <div
            v-if="category.children.length > 0"
            class="list-container"
          >
            <div
              v-for="demo in category.children"
              :key="demo.category_id"
              class="list-item"
            >
              <div
                v-lazy:background-image="demo.pic_url"
                class="demo-img"
                @click="onEnterDemo(category, demo)"
              />
              <div class="demo-name">
                {{ demo.name }}
              </div>
              <div class="demo-desc">
                {{ demo.desc }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 锚点组件 -->
      <div class="anchor-wrapper">
        <demo-anchor
          ref="demoAnchor"
          :anchor-list="anchorData"
          :category-positions="categoryPositionList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getDemoList } from './service';
import DemoAnchor from '~/components/demo-anchor';
import util from '~/utils/index';
import { errorLogger } from '~/utils/logger';

export default {
  layout: 'demo',
  // validate({ params }) {
  //   const pathArr = params.pathMatch.split('/').filter(path => !!path);
  //   console.log('validate pathArr: ', pathArr, pathArr.length > 4);
  //   if (pathArr.length > 4) {
  //     return false;
  //   }
  //   return true;
  // },
  middleware: 'handleHost',
  components: {
    DemoAnchor,
  },
  async asyncData({ params, navInit, script }) {
    try {
      const path = params.pathMatch;
      const res = await getAllDemoList(`/${path}`);
      return {
        path,
        demoData: res,
        navInit,
        script,
      };
    } catch (err) {
      console.error(err);
      errorLogger(err);
    }
  },
  data() {
    return {
      demoList: [],
      anchorData: [],
      categoryPositionList: [],
    };
  },
  computed: {
    isThirdDemo() { // 目录结构是否为3级
      const { demoData } = this;
      if (!Array.isArray(demoData)) {
        return;
      }
      const data = demoData.filter(item => {
        const { type, sub_categorys } = item;
        if (type === 1) {
          if (Array.isArray(sub_categorys) && sub_categorys.length > 0) {
            const list = sub_categorys.filter(subItem => {
              const { type: subType, sub_categorys: subCategorys } = subItem;
              return subType === 1 && Array.isArray(subCategorys) && subCategorys.filter(item => item.type === 2).length > 0;
            });
            return list.length > 0;
          } else {
            return false;
          }
        } else {
          return false;
        }
      });

      return data.length > 0;
    },
  },
  mounted() {
    console.log('demolist mounted: ');
    util.initPageComponents(this.navInit);
    try {
      this.handleDemoData(this.demoData);
    } catch (err) {
      console.error(err);
    }
    // 锚点相关设置
    this.$nextTick(() => {
      const index = window.location.hash.substr(1);
      // console.log('index: ', decodeURIComponent(index));
      if (index) {
        this.$refs.demoAnchor.onChangeAnchor(decodeURIComponent(index));
      }
      this.categoryPositionList = this.demoList.map(demo => {
        const { name } = demo;
        return {
          name,
          height: document.getElementById(name).offsetTop
        };
      });
      // console.log('this.categoryPositionList: ', this.categoryPositionList);
    });
  },
  methods: {
    // 分类处理示例数据
    handleDemoData(demoData) {
      const anchorList = [];
      if (!Array.isArray(demoData)) {
        return;
      }
      demoData.forEach(item => {
        if (isVaildCategory(item)) {
          anchorList.push(item);
        }
      });
      // console.log('anchorList: ', anchorList);
      if (this.isThirdDemo) {
        this.anchorData = this.handleAnchorData(anchorList, 2);
        const demos = anchorList.map(item => {
          return item.sub_categorys.map(sub => {
            return {
              ...sub,
              parent_path: item.path_name,
            };
          });
        }).flat(1);
        this.demoList = this.handleDemoList(demos);
      } else {
        this.anchorData = this.handleAnchorData(anchorList, 1);
        this.demoList = this.handleDemoList(demoData);
      }
      // console.log('this.anchorData: ', this.anchorData);
      // console.log('this.demoList: ', this.demoList);
    },
    // 处理锚点数据，depth表示需处理的层级
    handleAnchorData(data, depth = 1) {
      if (depth === 1) {
        const anchors = getAnchors(data);
        return anchors.length ? [{
          id: 0,
          name: '',
          children: getAnchors(data),
        }] : [];
      } else {
        const result = [];
        data.forEach(item => {
          const { category_id, name, sub_categorys } = item;
          const secondCategorys = sub_categorys.filter(subItem => {
            return isVaildCategory(subItem);
          });
          if (secondCategorys.length > 0) {
            const anchors = getAnchors(secondCategorys);
            if (anchors.length > 0) {
              result.push({
                id: category_id,
                name,
                children: anchors,
              });
            }
          }
        });

        return result;
      }
    },
    // 处理卡片示例数据
    handleDemoList(data) {
      // console.log('handleDemoList: ', data);
      const result = [];
      data.forEach(item => {
        const { sub_categorys, type } = item;
        if (type === 1 && Array.isArray(sub_categorys) && sub_categorys.length > 0) {
          const list = item.sub_categorys.filter(subItem => subItem.type === 2);
          list.length > 0 && result.push({
            ...item,
            children: list,
          });
        }
      });

      return result;
    },
    // 拼接示例详情的url
    onEnterDemo(category, demo) {
      const url = `/webDemoCenter/${this.path}/${category.parent_path ? `${category.parent_path}/` : ''}${category.path_name}/${demo.path_name}`;
      this.$router.push(url);
    }
  },
  head() {
    return {
      title: '示例中心 | 腾讯位置服务',
      meta: [
        { hid: 'description', name: 'description', content: '腾讯地图开放平台为各类应用厂商和开发者提供基于腾讯地图的地理位置服务和解决方案；有针对Web应用的JavaScript API, 适合手机端Native APP的各种SDK, WebService接口和各类地图API等。' },
        { hid: 'keywords', name: 'keywords', content: '腾讯地图开放平台，腾讯地图api，qq地图，腾讯地图街景api，地图api，手机定位api，腾讯lbs，qq map api，qq地图api' }
      ],
      script: this.script
    };
  },
};

async function getAllDemoList(pathName) {
  try {
    const data = await getDemoList({
      path_name: pathName,
      level: 10
    });
    return data && data.categorys;
  } catch (err) {
    console.error(err);
  }
};

// 是否为包含次级内容的有效目录
function isVaildCategory(data) {
  const { type, sub_categorys } = data;
  return type === 1 && Array.isArray(sub_categorys) && sub_categorys.length > 0;
}

// 处理得到包含web示例的目录信息
function getAnchors(data) {
  return data.filter(item => {
    return item.sub_categorys.filter(subItem => subItem.type === 2).length > 0;
  }).map(item => {
    return {
      id: item.category_id,
      name: item.name,
    };
  });
}

</script>
<style lang="less" src="./index.less" scoped>
</style>
